import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  reduce, each, delay, first, findIndex,
  set, get, uniq, keyBy, slice, replace, map,
  cloneDeep, indexOf, values, find, random,
  orderBy,
} from 'lodash';
import moment from 'moment';
import { Element, animateScroll } from 'react-scroll';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import ProgressBar from '../../../../components/progress-bar';
import MoneyDisplay from '../../../../components/money-display';

import {
  getTVCollectorMappings,
  getTVProductDictionary,
} from '../../../Setup/SetupReducer';

import {
  loadCompetitors,
  loadPricePositions,
  loadAttributes,
  loadCriateria,
  submitSellerFeedbacks,
} from '../../../Dashboard/DashboardActions';

import questionTypes from './question-types';
import FeedbackField from './feedback-field';
import { getUser } from '../../../Auth/AuthReducer';
import ProgramType from '../../../../components/program-type';

const GREETING = '0';
const HAS_COMPETITION_QUESTION = '1';
const PRIMARY_COMPETITION_QUESTION = '2';
const PRICE_POSITION_QUESTION = '3';
const OTHER_PRIMARY_COMPETITION_QUESTION = '4';
const REASON_CATEGORY_QUESTION = '5';
const REASON_ATTRIBUTE_QUESTION = '6';

const SELLER_REASON_QUESTION = '8';
const SELLER_REASON_APPLIES_QUESTION = '9';
const SELLER_REASON_HAS_MORE = '10';
const SUBMITTING = '11';
const THANKS = '12';

const OTHER_COMPETITOR_VALUE = '__OTHER__';

const QUESTION_TEMPLATES = [
  {
    value: GREETING,
    labels: [
      '[[greeting]], [[userName]]!',
      '[[secondGreeting]]',
      '[[introText]]',
    ],
    type: questionTypes.QUESTION_TYPE_STATIC,
    allowAddAnswer: true,
    options: [], // need to query, ability to add new, ability to skip
  },

  {
    value: HAS_COMPETITION_QUESTION,
    labels: ['Was there competition?'],
    type: questionTypes.QUESTION_TYPE_PICKLIST,
    paramName: 'has_competitor',
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
  },

  {
    value: PRIMARY_COMPETITION_QUESTION,
    labels: ['Who was the primary competitor?'],
    optionText: 'Please select the primary competitor we were competing with:',
    type: questionTypes.QUESTION_TYPE_PICKLIST,
    paramName: 'primary_competitor_id',
    options: [], // need to query, ability to add new, ability to skip
  },

  {
    value: OTHER_PRIMARY_COMPETITION_QUESTION,
    labels: ['What was that competitor name?'],
    type: questionTypes.QUESTION_TYPE_TEXT,
    paramName: 'primary_competitor_name',
    options: [], // need to query, ability to add new, ability to skip
  },

  {
    value: PRICE_POSITION_QUESTION,
    labels: ['Which option best describes our total cost compared to [[competitorName]]\'s total cost?'],
    type: questionTypes.QUESTION_TYPE_PICKLIST,
    paramName: 'price_position_value',
    hidden: { primary_competitor_id: null },
    options: [],
  },
  {
    value: REASON_CATEGORY_QUESTION,
    labels: [
      'What was the primary reason we [[outcomed]]?',
      'Please select the major decision driver category that best describes the reason.',
    ],
    type: questionTypes.QUESTION_TYPE_PICKLIST,
    loopGroupStart: true,
    loopGroup: 'reasons',
    paramName: 'reasons[x].category',
  },
  {
    value: REASON_ATTRIBUTE_QUESTION,
    labels: [
      'Which category best describes the reason we [[outcomed]]?',
    ],
    loopGroup: 'reasons',
    type: questionTypes.QUESTION_TYPE_PICKLIST,
    paramName: 'reasons[x].attribute_id',
    options: [], // load
  },
  {
    value: SELLER_REASON_QUESTION,
    labels: ['How did the &ldquo;[[attribute]]&rdquo; help us [[outcome]]?'],
    type: questionTypes.QUESTION_TYPE_TEXT,
    multipleLines: true,
    loopGroup: 'reasons',
    paramName: 'reasons[x].reason',
    options: [],
  },
  {
    value: SELLER_REASON_APPLIES_QUESTION,
    labels: ['Who does this reason apply to?'],
    type: questionTypes.QUESTION_TYPE_PICKLIST,
    loopGroup: 'reasons',
    paramName: 'reasons[x].vendor_id',
    options: [], // populate this with client or compentitor name & id, only display this question when we have competitor
  },
  {
    value: SELLER_REASON_HAS_MORE,
    labels: ['Was there another reason we [[outcomed]]?'],
    type: questionTypes.QUESTION_TYPE_PICKLIST,
    loopGroup: 'reasons',
    loopGroupEnd: true,
    paramName: 'reasons[x].has_more',
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ], // yes, no
  },
  {
    value: SUBMITTING,
    labels: [
      'We are submitting your feedback to help us win more in the future.',
      'One moment please...',
    ],
    type: questionTypes.QUESTION_TYPE_STATIC,
    options: [], // yes, no
  },
  {
    value: THANKS,
    labels: [
      'Thank you for providing your feedback on this [[stage]].',
      'Have a nice day, [[userName]]! And best of luck with your other sales opportunities! ☀️',
    ],
    type: questionTypes.QUESTION_TYPE_STATIC,
    options: [], // yes, no
  },
];


class FeedbackForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbacks: [],
      activeFeedback: null,
      loopGroups: {},
      selectedCompetitor: null,
      selectedProgram: null,
      tvProductIds: [],
      
      competitors: null,
      pricePositions: null,

      attributes: null,

      loadingCriateria: false,
    };
    this.getOptions = this.getOptions.bind(this);
    this.handleSelectOption = this.handleSelectOption.bind(this);
    this.handleFeedbackAdded = this.handleFeedbackAdded.bind(this);
    this.selectProgram = this.selectProgram.bind(this);
  }

  componentWillMount() {
    const activeFeedback = this.makeFeedback(first(this.getFeedbackTemplates()));
    const feedbacks = [activeFeedback];
    const selectedProgram = this.props.clientInitiatives && this.props.clientInitiatives.length === 1 ? this.props.clientInitiatives[0] : null;
    if (selectedProgram) {
      this.selectProgram(selectedProgram);
    }
    this.setState({ feedbacks, activeFeedback });
  }

  getFeedbackTemplates() {
    return QUESTION_TEMPLATES;
  }

  getPrimaryCompetitors() {
    const { selectedProgram, tvProductIds } = this.state;
    const p = new Promise((resolve, reject) => {
      if (!this.state.competitors) {
        this.props.dispatch(loadCompetitors(selectedProgram.client_id, selectedProgram.program_id, tvProductIds))
          .then(
            (results) => {
              this.setState({ competitors: results }, () => {
                resolve(results);
              });
            },
            (e) => {
              reject(e);
            },
          );
      } else {
        resolve(this.state.competitors);
      }
    });
    return new Promise((resolve, reject) => {
      p.then(
        (competitors) => {
          const validCompetitors = reduce(competitors, (items, competitor) => {
            if (!competitor.vendor_is_client) {
              items.push({
                value: `${competitor.vendor_id}`,
                label: competitor.vendor_name,
              });
            }
            return items;
          }, []);
          validCompetitors.push({ value: OTHER_COMPETITOR_VALUE, label: 'Other competitor' });
          resolve(validCompetitors);
        },
        (e) => {
          reject(e);
        },
      );
    });
  }

  getPricePositions() {
    const { selectedProgram, tvProductIds } = this.state;
    const p = new Promise((resolve, reject) => {
      if (!this.state.pricePositions) {
        this.props.dispatch(loadPricePositions(selectedProgram.client_id, selectedProgram.program_id, tvProductIds))
          .then(
            (results) => {
              this.setState({ pricePositions: results }, () => {
                resolve(results);
              });
            },
            (e) => {
              reject(e);
            },
          );
      } else {
        resolve(this.state.pricePositions);
      }
    });
    return new Promise((resolve, reject) => {
      p.then(
        (pricePositions) => {
          resolve(pricePositions);
        },
        (e) => {
          reject(e);
        },
      );
    });
  }

  getCategories() {
    const { selectedProgram, tvProductIds } = this.state;
    const { opportunity: { stage, types } } = this.props;
    const opportunityType = first(types);

    const p = new Promise((resolve, reject) => {
      if (!this.state.attributes) {
        this.props.dispatch(loadAttributes(selectedProgram.client_id, selectedProgram.program_id, tvProductIds))
          .then(
            (results) => {
              this.setState({ attributes: results }, () => {
                resolve(results);
              });
            },
            (e) => {
              reject(e);
            },
          );
      } else {
        resolve(this.state.attributes);
      }
    });


    // https://github.com/lumen-software/TruSales/issues/1496
    const excludedCategories = [1, 2, 3, 10, 100, 11, 12, 8];
    const validOpportunityTypes = ['Renewal', 'Add-on', 'Upsell'];

    return new Promise((resolve, reject) => {
      p.then(
        (attributes) => {
          const isNoDecision = stage === 'No Decision';
          // https://github.com/lumen-software/TruSales/issues/1218
          // https://github.com/lumen-software/TruSales/issues/1195
          // https://github.com/lumen-software/TruSales/issues/1496
          const validCategories = values(reduce(attributes, (items, attribute) => {
            if (indexOf(excludedCategories, attribute.category_id) < 0) {
              // https://github.com/lumen-software/TruSales/issues/1496
              /*
              category_id = 14: Only display this category if the opportunity type == renewal or upsell or addon
              */
              
              const validType = (attribute.category_id === 14 && indexOf(validOpportunityTypes, opportunityType) >= 0) || attribute.category_id !== 14;
              const validStage = (!isNoDecision && attribute.category_label !== 'Business Case') || isNoDecision;

              if (validType && validStage) {
                items[attribute.category_id] = {
                  id: attribute.category_id,
                  value: attribute.category_label, // attribute.category_id is not UNIQUE!
                  label: this.translateCategory(attribute),
                };
              }
            }
            return items;
          }, {}));

          // https://github.com/lumen-software/TruSales/issues/1496
          const cats = orderBy(values(validCategories), (cat, i) => {
            if (cat.id === 4) {
              return 1;
            }
            if (cat.id === 5) {
              return 2;
            }
            if (cat.id === 13) {
              return 3;
            }
            if (cat.id === 6) {
              return 4;
            }
            if (cat.id === 14) {
              return 5;
            }
            if (cat.id === 7) {
              return 6;
            }
            return (i + 1) * 100;
          });
          resolve(cats);
        },
        (e) => {
          reject(e);
        },
      );
    });
  }

  getAttributes(q) {
    const { selectedProgram, tvProductIds } = this.state;
    const params = this.getSubmitParams();
    const path = `reasons[${q.loopIndex}].category`;
    const val = get(params, path);

    const p = new Promise((resolve, reject) => {
      if (!this.state.attributes) {
        this.props.dispatch(loadAttributes(selectedProgram.client_id, selectedProgram.program_id, tvProductIds))
          .then(
            (results) => {
              this.setState({ attributes: results }, () => {
                resolve(results);
              });
            },
            (e) => {
              reject(e);
            },
          );
      } else {
        resolve(this.state.attributes);
      }
    });
    return new Promise((resolve, reject) => {
      p.then(
        (attributes) => {
          // https://github.com/lumen-software/TruSales/issues/1195
          const validAttributes = reduce(attributes, (items, attribute) => {
            if (attribute.category_label === val) {
              items.push({
                value: `${attribute.id}`,
                label: attribute.seller_label || attribute.buyer_label,
                description: attribute.seller_definition,
              });
            }
            return items;
          }, []);
          resolve(validAttributes);
        },
        (e) => {
          reject(e);
        },
      );
    });
  }

  getVendors() {
    const { selectedProgram, tvProductIds } = this.state;
    const params = this.getSubmitParams();
    const p = new Promise((resolve, reject) => {
      if (!this.state.competitors) {
        this.props.dispatch(loadCompetitors(selectedProgram.client_id, selectedProgram.program_id, tvProductIds))
          .then(
            (results) => {
              this.setState({ competitors: results }, () => {
                resolve(results);
              });
            },
            (e) => {
              reject(e);
            },
          );
      } else {
        resolve(this.state.competitors);
      }
    });
    return new Promise((resolve, reject) => {
      p.then(
        (competitors) => {
          const validCompetitors = reduce(competitors, (items, competitor) => {
            if (competitor.vendor_is_client || (params.primary_competitor_id === competitor.vendor_id)) {
              items.push({
                value: `${competitor.vendor_id}`,
                label: competitor.vendor_name,
              });
            }
            return items;
          }, []);
          if (params.has_competitor && params.primary_competitor_id === OTHER_COMPETITOR_VALUE) {
            validCompetitors.push({
              value: OTHER_COMPETITOR_VALUE,
              label: params.primary_competitor_name,
            });
          }
          resolve(validCompetitors);
        },
        (e) => {
          reject(e);
        },
      );
    });
  }

  getHasCompetitorOptions(q) {
    return Promise.resolve(q.options);
  }

  getHasMoreOptions(question) {
    return Promise.resolve(question.options);
  }

  getOptions(question) {
    const { value } = question;
    let p = new Promise((resolve, reject) => {
      reject(new Error('need handler'))
    });
    p.then(() => {}, () => {});
    if (value === PRIMARY_COMPETITION_QUESTION) {
      p = this.getPrimaryCompetitors(question);
    } else if (value === PRICE_POSITION_QUESTION) {
      p = this.getPricePositions(question);
    } else if (value === REASON_CATEGORY_QUESTION) {
      p = this.getCategories(question);
    } else if (value === REASON_ATTRIBUTE_QUESTION) {
      p = this.getAttributes(question);
    } else if (value === SELLER_REASON_APPLIES_QUESTION) {
      p = this.getVendors(question);
    } else if (value === SELLER_REASON_HAS_MORE) {
      p = this.getHasMoreOptions(question);
    } else if (value === HAS_COMPETITION_QUESTION) {
      p = this.getHasCompetitorOptions(question);
    }
    return p;
  }


  getSubmitParams(cleanUp = false) {
    const feedbacks = [...this.state.feedbacks];
    const params = {};
    each(feedbacks, (feedback) => {
      if (feedback.paramName) {
        set(params, feedback.paramName, feedback.response);
      }
    });
    if (cleanUp) {
      if (params.primary_competitor_id === OTHER_COMPETITOR_VALUE) {
        delete params.primary_competitor_id;
      }
      delete params.has_competitor;
      each(params.reasons, (reason) => {
        delete reason.category;
        delete reason.has_more;
        if (reason.vendor_id === OTHER_COMPETITOR_VALUE) {
          delete reason.vendor_id;
          reason.vendor_name = params.primary_competitor_name;
        }
      });
    }
    return params;
  }

  getGreatings() {
    const words = ['\'Allo', 'Ahoy', 'G\'day', 'Hello', 'Hey', 'Hi', 'Hiya', 'How are things', 'How\'s it going', 'Howdy'];

    const now = moment().hours();
    let g = null;
    if (now >= 17 || now < 5) {
      g = 'Good Evening';
    } else if (now >= 12) {
      g = 'Good Afternoon';
    } else if (now >= 5) {
      g = 'Good Morning';
    }
    if (g) {
      words.push(g);
    }
    return words[random(0, words.length - 1)];
  }

  getTokens(state) {
    const { user, opportunity } = this.props;
    const { selectedCompetitor } = state || this.state;
    const { stage } = opportunity;
    let secondGreeting = '';
    let introText = null;
    let accountName = null;
    if (opportunity.account) {
      accountName = (<span>at <strong>{opportunity.account.name}</strong></span>);
    }
    const opportunityName = (<strong>{opportunity.name}</strong>);
    const dealSize = (<MoneyDisplay value={opportunity.amount} abbreviated precision={0} />);
    let stageLabel = 'won';
    let stageLabelPresent = 'win';
    let stageVerb = 'win';
    if (stage === 'Lost') {
      stageLabel = 'lost';
      stageLabelPresent = 'loss';
      stageVerb = 'loss';
      secondGreeting = 'Really sorry about the loss. We\'ll use your feedback to figure out how we can win these opportunities in the future. 💪';
      introText = (<span>Let&rsquo;s take a moment to review why we lost this {dealSize} {opportunityName} {accountName}.</span>);
    } else if (stage === 'No Decision') {
      stageLabel = 'pushed';
      stageLabelPresent = 'push';
      stageVerb = 'no decision';
      secondGreeting = 'Really sorry about the no decision. We\'ll use your feedback to figure out how we can win this opportunity in the future. 💪';
      introText = (<span>Let&rsquo;s take a moment to review why this {dealSize} {opportunityName} {accountName} pushed.</span>);
    } else if (stage === 'Won') {
      secondGreeting = 'Congrats on the win! Nice work! 👏';
      introText = (<span>Let&rsquo;s take a moment to review why we won this {dealSize} {opportunityName} {accountName}.</span>);
    }

    const params = this.getSubmitParams();
    let competitorName = 'primary competitor';
    if (selectedCompetitor) {
      competitorName = selectedCompetitor.label;
    } else if (params.has_competitor) {
      competitorName = params.primary_competitor_name;
    }

    const tokens = {
      userName: user.first_name,
      opportunityName: opportunity.name,
      closeDate: moment(opportunity.close_date).format('MMM DD, YYYY'),
      outcomed: stageLabel,
      outcome: stageLabelPresent,
      stage: stageVerb,
      competitorName,
      secondGreeting,
      greeting: this.getGreatings(),
      introText,
    };
    return tokens;
  }

  translateCategory(attribute) {
    /*
    // https://github.com/lumen-software/TruSales/issues/1218
    if (text === 'Solution') {
      return 'Our product or solution';
    } else if (text === 'Sales Team') {
      return 'Their sales experience with us';
    } else if (text === 'Company') {
      return 'Our company or brand';
    } else if (text === 'Support') {
      return 'Their support experience with us';
    } else if (text === 'Pricing & Value') {
      return 'Our pricing';
    } else if (text === 'Solution Value') {
      return 'The benefits or results they wanted';
    }
    */
    const id = attribute.category_id;
    // https://github.com/lumen-software/TruSales/issues/1496
    if (id === 4) {
      return 'Our product or solution';
    }
    if (id === 5) {
      return 'Our pricing or perceived value';
    }
    if (id === 13) {
      return 'The benefits or results they wanted';
    }
    if (id === 6) {
      return 'Their sales experience with us';
    }
    if (id === 14) {
      return 'Their support experience with us';
    }
    if (id === 7) {
      return 'Our company or brand';
    }
    
    return attribute.category_label;
  }

  makeFeedback(template, state) {
    const id = template.paramName || template.value;
    const newFeedback = { id, ...cloneDeep(template), response: null };
    const tokens = this.getTokens(state);
    const params = this.getSubmitParams();

    const newLoopGroups = { ...this.state.loopGroups };
    if (newFeedback.loopGroup) {
      if (newFeedback.loopGroupStart) {
        if (newLoopGroups[newFeedback.loopGroup] === undefined) {
          newLoopGroups[newFeedback.loopGroup] = 0;
        }
      }
      const idx = newLoopGroups[newFeedback.loopGroup];
      newFeedback.loopIndex = idx;
      if (idx !== undefined) {
        newFeedback.paramName = replace(newFeedback.paramName, '[x]', `[${idx}]`);
        newFeedback.id = newFeedback.paramName;
      }
      if (newFeedback.loopGroupEnd) {
        if (newLoopGroups[newFeedback.loopGroup] !== undefined) {
          newLoopGroups[newFeedback.loopGroup] += 1;
        }
      }
      const path = `reasons[${idx}].attribute_id`;
      const attrId = get(params, path);
      const attr = find(this.state.attributes, { id: attrId });
      if (attr) {
        tokens.attribute = attr.seller_label || attr.buyer_label;
      }
      this.setState({ loopGroups: newLoopGroups });
    }
    newFeedback.labels = reduce(newFeedback.labels, (labels, text, i) => {
      let replacedText = text;
      
      each(tokens, (v, k) => {
        if (typeof v === 'string' && typeof replacedText === 'string') {
          replacedText = replace(replacedText, `[[${k}]]`, v);
        } else if (replacedText === `[[${k}]]`) {
          replacedText = v; // no replace
        }
      });
      labels.push({ id: `${(i + 1)}`, text: replacedText });
      return labels;
    }, []);
    return newFeedback;
  }

  handleSelectOption(question, option) {
    if (!question) {
      return;
    }
    const indexedFeedback = keyBy(this.getFeedbackTemplates(), 'value');
    let feedbacks = [...this.state.feedbacks];

    if (option && question.paramName) {
      const idx = findIndex(feedbacks, { id: question.id });
      if (idx >= 0) {
        feedbacks[idx].response = option.value;
      }
    }
    const params = this.getSubmitParams();
    let newSelectedCompetitor = this.state.selectedCompetitor;
    let nextFeedback = null;
    
    if (question.value === GREETING) {
      nextFeedback = indexedFeedback[HAS_COMPETITION_QUESTION];
      newSelectedCompetitor = null;
    } else if (question.value === HAS_COMPETITION_QUESTION) {
      if (option.value) {
        nextFeedback = indexedFeedback[PRIMARY_COMPETITION_QUESTION];
      } else {
        nextFeedback = indexedFeedback[REASON_CATEGORY_QUESTION];
      }
      newSelectedCompetitor = null;
    } else if (question.value === PRIMARY_COMPETITION_QUESTION) {
      if (option.value === OTHER_COMPETITOR_VALUE) {
        nextFeedback = indexedFeedback[OTHER_PRIMARY_COMPETITION_QUESTION];
        newSelectedCompetitor = null;
      } else {
        newSelectedCompetitor = option;
        nextFeedback = indexedFeedback[PRICE_POSITION_QUESTION];
      }
    } else if (question.value === OTHER_PRIMARY_COMPETITION_QUESTION) {
      nextFeedback = indexedFeedback[PRICE_POSITION_QUESTION];
    } else if (question.value === PRICE_POSITION_QUESTION) {
      nextFeedback = indexedFeedback[REASON_CATEGORY_QUESTION];
    } else if (question.value === REASON_CATEGORY_QUESTION) {
      nextFeedback = indexedFeedback[REASON_ATTRIBUTE_QUESTION];
    } else if (question.value === REASON_ATTRIBUTE_QUESTION) {
      nextFeedback = indexedFeedback[SELLER_REASON_QUESTION];
    } else if (question.value === SELLER_REASON_QUESTION) {
      // do we have a competitor?
      // if no, then go to SELLER_REASON_HAS_MORE
      if (params.has_competitor) {
        nextFeedback = indexedFeedback[SELLER_REASON_APPLIES_QUESTION];
      } else {
        nextFeedback = indexedFeedback[SELLER_REASON_HAS_MORE];
      }
    } else if (question.value === SELLER_REASON_APPLIES_QUESTION) {
      nextFeedback = indexedFeedback[SELLER_REASON_HAS_MORE];
    } if (question.value === SELLER_REASON_HAS_MORE) {
      if (option.value) {
        nextFeedback = indexedFeedback[REASON_CATEGORY_QUESTION];
      } else {
        nextFeedback = indexedFeedback[SUBMITTING];
      }
    } if (question.value === SUBMITTING) {
      // TODO: do submit, then go to next
      this.doSubmit();
    }

    const questionIndex = findIndex(this.state.feedbacks, { id: question.id });
    if (questionIndex >= 0) {
      feedbacks = slice(feedbacks, 0, questionIndex + 1);
    }

    let newActiveFeedback = null;
    if (nextFeedback) {
      newActiveFeedback = this.makeFeedback(nextFeedback, { selectedCompetitor: newSelectedCompetitor });
      feedbacks.push(newActiveFeedback);
    }

    this.setState({
      feedbacks,
      activeFeedback: newActiveFeedback || this.state.activeFeedback,
      selectedCompetitor: newSelectedCompetitor,
    }, () => {
      this.props.onFeedbackAdded(newActiveFeedback);
      this.handleFeedbackAdded(question);
    });
  }


  handleFeedbackAdded() {
    animateScroll.scrollToBottom({
      duration: 1000,
      delay: 100,
      isDynamic: true,
      smooth: 'easeInOutQuart',
      containerId: 'feedbackContainerElement',
    });
  }


  doSubmit() {
    const { selectedProgram } = this.state;
    const { opportunity } = this.props;
    const feedbacks = [...this.state.feedbacks];
    const indexedFeedback = keyBy(this.getFeedbackTemplates(), 'value');
    const params = this.getSubmitParams(true);

    this.props.dispatch(submitSellerFeedbacks(selectedProgram.client_id, selectedProgram.program_id, opportunity.opportunity_id, params))
      .then(
        () => {
          const activeFeedback = this.makeFeedback(indexedFeedback[THANKS]);
          feedbacks.push(activeFeedback);
          this.setState({ feedbacks, activeFeedback });
          this.handleFeedbackAdded();
          delay(
            () => {
              this.props.onSuccess(true);
            },
            1000,
          );
        },
        (e) => {
          let message = 'Unknown Error';
          if (e.data && e.data.message) {
            ({ message } = e.data);
          }
          const thanks = indexedFeedback[THANKS];

          const activeFeedback = this.makeFeedback({
            ...thanks,
            labels: [
              `Submit error: ${message}`,
            ],
          });
          feedbacks.push(activeFeedback);
          this.setState({ feedbacks, activeFeedback });
          this.handleFeedbackAdded();
          delay(
            () => {
              this.props.onSuccess(false);
            },
            1000,
          );
        },
      );
  }

  selectProgram(selectedProgram) {
    const { tvProductMappings, opportunity } = this.props;
    const tsProductIds = map(opportunity.line_items, 'product_id');
    const tvProductIds = uniq(reduce(tvProductMappings, (items, mappings, tsProductId) => {
      if (indexOf(tsProductIds, tsProductId) >= 0) {
        each(mappings, (mapping) => {
          if (mapping.program_id === selectedProgram.program_id && mapping.client_id === selectedProgram.client_id) {
            items.push(mapping.id);
          }
        });
      }
      return items;
    }, []));

    this.setState({ loadingCriateria: true, selectedProgram, tvProductIds }, () => {
      this.props.dispatch(loadCriateria(selectedProgram.client_id, selectedProgram.program_id, tvProductIds))
        .then(
          ({ attributes, competitors, pricePositions }) => {
            this.setState({
              loadingCriateria: false, attributes, competitors, pricePositions,
            });
          },
          () => {},
        );
    });
  }
  
  renderProgramSelector() {
    const { clientInitiatives } = this.props;
    let currentClientId = null;
    return (
      <div>
        <DropdownButton
          onSelect={this.selectProgram}
          bsStyle="default"
          bsSize="lg"
          block
          title="Please select an initiative"
          id="program-filter"
        >
          {clientInitiatives.map((c) => {
            const comps = [];
            if (c.client_id !== currentClientId) {
              if (currentClientId) {
                comps.push((
                  <MenuItem divider key={`${currentClientId}-divider`} />
                ));
              }
              comps.push((
                <MenuItem header key={c.client_id}>{c.client_name}</MenuItem>
              ));
              currentClientId = c.client_id;
            }
            comps.push((
              <MenuItem eventKey={c} key={`${c.client_id}|${c.program_id}`}>
                <span><ProgramType type={c.program_type_name} /> {c.program_name}</span>
              </MenuItem>
            ));
            return comps;
          })}
        </DropdownButton>
      </div>
    );
  }

  render() {
    const {
      activeFeedback, feedbacks, selectedProgram,
      loadingCriateria,
    } = this.state;
    const { maxHeight } = this.props;

    if (!selectedProgram) {
      return this.renderProgramSelector();
    }
    if (loadingCriateria) {
      return (<ProgressBar />);
    }

    const style = {};
    if (maxHeight !== null) {
      style.maxHeight = maxHeight;
      style.overflowY = 'auto';
      style.overflowX = 'hidden';
    }

    return (
      <Element id="feedbackContainerElement" style={style}>
        {feedbacks.map((feedback) => {
          const isActive = activeFeedback && activeFeedback.id === feedback.id;
          return (
            <FeedbackField
              key={feedback.id}
              feedback={feedback}
              disabled={!isActive}
              getOptions={this.getOptions}
              selectOption={this.handleSelectOption}
              onOptionLoaded={this.handleFeedbackAdded}
            />
          );
        })}
      </Element>
    );
  }
}

FeedbackForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
    name: PropTypes.string,
    stage: PropTypes.string,
    amount: PropTypes.number,
    account: PropTypes.shape({
      name: PropTypes.string,
    }),
    line_items: PropTypes.arrayOf(PropTypes.shape({
      product_id: PropTypes.string,
    })),
    types: PropTypes.arrayOf(PropTypes.string),
  }),
  collectors: PropTypes.shape({}),
  collectorTypes: PropTypes.arrayOf(PropTypes.string),
  tvProductMappings: PropTypes.shape({}),
  clientInitiatives: PropTypes.arrayOf(PropTypes.shape({
    client_id: PropTypes.string,
    client_name: PropTypes.string,
    program_id: PropTypes.string,
    program_name: PropTypes.string,
    program_type_value: PropTypes.number,
    program_type_name: PropTypes.string,
  })),
  onFeedbackAdded: PropTypes.func,
  maxHeight: PropTypes.number,
  onSuccess: PropTypes.func,
  user: PropTypes.shape({
    first_name: PropTypes.string,
  }).isRequired,
};
FeedbackForm.defaultProps = {
  opportunity: null,
  collectorTypes: [],
  tvProductMappings: {},
  clientInitiatives: [],
  onFeedbackAdded: () => {},
  onSuccess: () => {},
  maxHeight: null,
};
FeedbackForm.contextTypes = {
};

function mapStateToProps(state, ownProps) {
  const tvProductMappings = getTVProductDictionary(state);

  const tvCollectors = getTVCollectorMappings(state);

  const checkedIndexed = {};

  const clientInitiatives = reduce(tvCollectors, (clients, client) => {
    each(client.programs, (program) => {
      each(ownProps.collectorTypes, (collectorType) => {
        if (program[`${collectorType}_collector_id`]) {
          clients.push({
            client_id: client.id,
            client_name: client.name,
            program_id: program.id,
            program_name: program.name,
            program_type_value: program.type_value,
            program_type_name: program.type_name,
          });
          checkedIndexed[`${client.id}|${program.id}`] = true;
        }
      });
    });
    return clients;
  }, []);

  const validProductMappings = reduce(tvProductMappings, (items, products, productId) => {
    items[productId] = reduce(products, (subItems, product) => {
      if (checkedIndexed[`${product.client_id}|${product.program_id}`]) {
        subItems.push(product);
      }
      return subItems;
    }, []);
    return items;
  }, {});
  return {
    tvProductMappings: validProductMappings,
    clientInitiatives,
    user: getUser(state),
  };
}

export default connect(mapStateToProps)(FeedbackForm);
